<template>
    <div class="h-100">
        <v-col v-if="loading" class="h-100"
            ><div class="d-flex align-center justify-center h-100">
                <v-progress-circular :width="5" :size="80" color="primary" indeterminate></v-progress-circular></div
        ></v-col>
        <div v-else>
            <v-col cols="12">
                <h2>{{ t('patients::notification.select_data_type') }}</h2>
            </v-col>
            <v-col v-if="can('api.v1.patients.pdf')" cols="12">
                <v-row>
                    <upload-widget v-for="item in items" :key="item.index" :item="item">
                        <template #action>
                            <v-btn
                                :color="item.color || 'primary'"
                                rounded
                                small
                                outlined
                                block
                                @click="uploadFile(item)"
                                >{{ t('patients::button.upload') }}
                                <v-icon right>mdi-chevron-right</v-icon>
                            </v-btn>
                        </template>
                    </upload-widget>
                </v-row>
            </v-col>
        </div>
        <div>
            <v-form>
                <b-file-input
                    ref="fileInput"
                    to-mutate="uploadPdf::form.file"
                    :label="t('quality-control::date.file')"
                    accept=".pdf"
                    mandatory
                    class="file d-none"
                    :prepend-icon="null"
                    :rules="validationRules.file"
                    @change="processFile"
                ></b-file-input>
            </v-form>
        </div>
    </div>
</template>

<script>
const UploadFromPdfMixin = require(process.env.MIX_APP_ROOT +
    '/modules/patients/resources/js/mixins/UploadFromPdfMixin.js').default;
export default {
    mixins: [UploadFromPdfMixin],
    props: {},
    data() {
        return {
            items: [
                {
                    title: t('patients::card.title.patient'),
                    icon: 'mdi-clipboard-account-outline',
                    action: 'upload-patient',
                    color: 'primary',
                    route: 'api.v1.patients.pdf',
                },
                // {
                //     title: 'Pharmacy',
                //     icon: 'mdi-arch',
                //     action: 'upload-pharmacy',
                //     color: 'primary',
                //     route: false,
                // },
                // {
                //     title: 'Website User',
                //     icon: 'mdi-table-account',
                //     action: 'upload-website-user',
                //     color: 'primary',
                //     route: false,
                // },
                // {
                //     title: 'Patient Transfer',
                //     icon: 'mdi-account-switch',
                //     action: 'transfer-patient',
                //     color: 'primary',
                //     route: false,
                // },
            ],
        };
    },
    computed: {
        formType() {
            return this.$store.state.uploadPdf.currentUploadFileForm;
        },
    },
    methods: {
        uploadFile(item) {
            if (!item && !item.action) {
                return;
            }
            this.$store.dispatch('uploadPdf/setFormType', item);
            this.$refs.fileInput.$children[0].$refs.input.click();
        },
    },
};
</script>

<style></style>
